import type { LocationQueryRaw, RouteLocationRaw } from 'vue-router'
import type { Config, TeamPid } from '@dashboard/types/config'
import { ROUTES } from '@dashboard/router/routeNames'

type QuestionConfig = Pick<Config, 'rightAsk'>

/** Resolves both canonical question IDs and the dimension IDs used by flow nodes. */
export function resolveQuestionId(
  config: QuestionConfig | null | undefined,
  id: string | null | undefined
): string | undefined {
  if (!config || !id) {
    return undefined
  }
  return config.rightAsk.questions.find((question) => question.id === id || question.dimensionId === id)?.id
}

export function questionLocation(teamId: TeamPid, questionId: string, query?: LocationQueryRaw): RouteLocationRaw {
  return { name: ROUTES.QUESTION, params: { teamPid: String(teamId), questionId }, ...(query ? { query } : {}) }
}
